import { setupForDark } from '@theme';
import classNames from 'classnames';

export default function GraphicWithText({
  graphic,
  headerVariant = 'primary',
  header,
  text
}: {
  graphic: React.ReactNode;
  headerVariant?: 'primary' | 'secondary';
  header: React.ReactNode;
  text?: string;
}) {
  return (
    <div className={classNames('flex flex-col justify-start items-center p-md gap-md')}>
      <div className='sm:w-[218px] w-[142px]'>{graphic}</div>
      {header && (
        <div
          className={classNames(
            'H3 text-center',
            setupForDark('text-primary'),
            headerVariant === 'primary' ? 'text-primary' : 'text-secondary'
          )}
        >
          {header}
        </div>
      )}
      {text && (
        <div className={classNames('P1M text-center', setupForDark('text-primary'))}>{text}</div>
      )}
    </div>
  );
}
